/**
 * HTTP status for job detail when the listing still exists in storage but should be treated as gone.
 * Returns 410 when expired/inactive; undefined means serve as 200.
 */
import { computeJobListingValidThroughMs, type JobListingValidityInput } from './compute-job-listing-valid-through';

export type JobListingStalenessInput = JobListingValidityInput & {
  isActive?: boolean;
};

export function getJobListingHttpStatusCode(job: JobListingStalenessInput, nowMs: number): number | undefined {
  if (job.isActive === false) {
    return 410;
  }
  return nowMs > computeJobListingValidThroughMs(job, nowMs) ? 410 : undefined;
}
